import { throttle } from 'throttle-debounce';

const Navigation = {
	path: '',
	Init() {
		// Using the current path (e.g. /Section/Page)
		Navigation.path = window.location.pathname;

		Navigation.Go(Navigation.path);
		Navigation.Go(window.location.search);

		if (Navigation.path.indexOf('print=true') >= 0) {
			window.print();
		}

		Navigation.KeepOpen();
		Navigation.MenuOverflow();
		Navigation.NavMain();
		Navigation.Navbar();

		$('#searchModal').on('shown.bs.modal', e => {
			document.getElementById('search').focus();
		});

		const $navSiblings = $('.nav--siblings');
		$navSiblings
			// .on('blur', function navSiblingsBlur(e) {
			// 	$(this).removeClass('js--menu-active');
			// })
			.find('a.active')
			.on('click', function activeSiblingNavItemClick(e) {
				e.preventDefault();
				$(this).parents('.nav--siblings').toggleClass('js--menu-active');
			})
			// .on('blur', function navSiblingsBlur(e) {
			// 	$(this)
			// 		.parents('.nav--siblings')
			// 		.removeClass('js--menu-active');
			// })
			.parent('li')
			.addClass('active');
	},
	Go(url) {
		// Handle links to the current path
		if (url) {
			const $currentPath = $(`a[href$="${url}"]:not(".alias"):not([href^="http"])`);
			$currentPath.parents('.collapse').each((i, collapse) => {
				$(collapse).addClass('show');
				$(`.nav-link[href="#${$(collapse).attr('id')}"]`).attr('aria-expanded', 'true');
			});
			$currentPath.addClass('active').attr('aria-current', 'page');

			let fragment = url;
			while (fragment.lastIndexOf('/') > 0) {
				fragment = fragment.substring(0, fragment.lastIndexOf('/'));
				$(
					`.navbar--main li:not(.breadcrumb-item) a[href$="${fragment}"], .l--main a[href$="${fragment}"], .nav--sitemap a[href$="${fragment}"], .nav--pagetitle a[href$="${fragment}"]`
				)
					.addClass('active')
					.parents()
					.filter('li')
					.addClass('active');
			}
		}
	},
	KeepOpen() {
		$('.dropdown.keep-open').on({
			click: function handleClick(e) {
				if ($(e.target).closest('.dropdown-toggle').length) {
					$(this).data('closable', true);
				} else {
					$(this).data('closable', false);
				}
			},
			'hide.bs.dropdown': function handleBsHide() {
				const hide = $(this).data('closable');
				$(this).data('closable', true);
				return hide;
			}
		});
	},
	MenuOverflow() {
		$('.dropdown--main-menu').on('show.bs.dropdown', () => {
			$('body').addClass('js--menu-open');
		});

		$('.dropdown--main-menu').on('hide.bs.dropdown', () => {
			$('body').removeClass('js--menu-open');
		});
	},
	NavMain() {
		$('.dropdown-menu--desktop').on('click', '.nav-link.toggle-child', function toggleHtml(e) {
			const myLevel = $(this).parents('.level').data('level');
			const $source = $($(this).attr('href'));
			const $target = $(`.level.level${myLevel + 1}`);

			$target.html($source.html());

			const $parentLevel = $(this).parents('.level');

			$parentLevel.find('.active').removeClass('active');
			$parentLevel.find('[aria-expanded]').attr('aria-expanded', 'false');
			$(this).addClass('active').attr('aria-expanded', 'true');

			$target.find('[data-toggle="collapse"]').removeAttr('data-toggle');
			$(`.level.level${myLevel} [data-toggle="collapse"]`).attr('aria-expanded', 'false');

			for (let i = myLevel + 2; i <= $('.level').length; i += 1) {
				$(`.level.level${i}`).html('');
			}
		});

		$('#navMainMenu .collapse.show').each(function setLevel(i, collapse) {
			const $level = $(`.level.level${i + 2}`);
			$level.html($(this).html());
			$level.find('[data-toggle="collapse"]').removeAttr('data-toggle');
		});

		let $level1 = $('.dropdown-menu--desktop .level1 a[aria-expanded="true"]').first();
		if ($level1.length === 0) {
			$level1 = $('.dropdown-menu--desktop .level1 a.active').first();
		}
		const $level1Title = $('.jumbotron--title').first();
		if ($level1Title.length > 0 && $level1Title.text().toLowerCase() !== $level1.text().toLowerCase()) {
			$('.navbar--main .level1 a').text($level1.text()).attr('href', $level1.data('href'));
		}

		let $level2 = $('.dropdown-menu--desktop .level2 a[aria-expanded="true"]').first();
		if ($level2.length === 0) {
			$level2 = $('.dropdown-menu--desktop .level2 a.active').first();
		}
		const $level2Title = $('.jumbotron--title').first();
		if ($level2Title.length > 0 && $level2Title.text().toLowerCase() !== $level2.text().toLowerCase()) {
			$('.navbar--main .level2 a').text($level2.text()).attr('href', $level2.data('href'));
		}

		$('.navbar--main .level2 a').text($level2.text()).attr('href', $level2.data('href'));

		const $level2list = $('.dropdown-menu--desktop .level2 ul').first();
		if ($level2list.find('li').length < 6) {
			$('.navbar--main .level4').append($level2list.html());
		}

		let $level3 = $('.dropdown-menu--desktop .level3 a[aria-expanded="true"]').first();
		if ($level3.length === 0) {
			$level3 = $('.dropdown-menu--desktop .level3 a.active').first();
		}
		const $level3Title = $('.jumbotron--title').first();
		if ($level3Title.length > 0 && $level3Title.text().toLowerCase() !== $level3.text().toLowerCase()) {
			$('.navbar--main .level3 a').text($level3.text()).attr('href', $level3.data('href'));
		}

		const $level3list = $('.dropdown-menu--desktop .level3 ul').first();
		if ($level3list.find('li').length < 6) {
			$('.navbar--main .level4').append($level3list.html());
		}

		const $level4 = $('.dropdown-menu--desktop .level4 ul').first();
		if ($level4.find('li').length < 6) {
			$('.navbar--main .level4').append($level4.html());
		}
	},
	Navbar() {
		const navbar = document.querySelector('.navbar--primary');
		const navbarOffset = navbar.offsetHeight;
		const navbarHeight = navbarOffset * 2;
		const mq = window.matchMedia('(min-width: 992px)');
		const navMiniClass = 'nav--mini';

		function miniNavigation() {
			if (window.scrollY >= navbarHeight && mq.matches && !navbar.classList.contains(navMiniClass)) {
				navbar.classList.add(navMiniClass);
				document.body.classList.add(`is-${navMiniClass}`);
				$('.dropdown--main-menu .btn--menu').dropdown('hide').attr('aria-expanded', 'hidden').blur();
			} else if (window.scrollY < navbarHeight && navbar.classList.contains(navMiniClass)) {
				navbar.classList.remove(navMiniClass);
				document.body.classList.remove(`is-${navMiniClass}`);
			}
		}

		window.addEventListener('scroll', throttle(100, miniNavigation));
	}
};

export default Navigation;
